import React, { useCallback, useEffect, useState } from 'react';
import Topbar from '@/components/layout/Topbar';
import { api } from '@/lib/api';
import { RefreshCw } from 'lucide-react';

const fmt = (n, d = 2) => (n === null || n === undefined || isNaN(n) ? '—' : Number(n).toFixed(d));

export default function Posiciones() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/positions');
      setItems(data.posiciones || []);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const close = async (pid) => { await api.post(`/positions/${pid}/close`); load(); };

  return (
    <>
      <Topbar
        title="Posiciones"
        subtitle={`${items.length} operaciones simuladas registradas`}
        right={
          <button onClick={load} className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-xs border border-border hover:bg-muted" data-testid="btn-refresh-positions">
            <RefreshCw size={14} /> Refrescar
          </button>
        }
      />
      <div className="px-3 sm:px-4 lg:px-6 py-4">
        <div className="panel overflow-hidden">
          <table className="w-full text-sm" data-testid="positions-table">
            <thead className="text-xs text-muted-foreground bg-muted/60">
              <tr>
                <th className="text-left py-2 px-3">Par</th>
                <th className="text-left py-2 px-3">Estrategia</th>
                <th className="text-right py-2 px-3">Entry fill</th>
                <th className="text-right py-2 px-3">Stop inicial</th>
                <th className="text-right py-2 px-3">Salida</th>
                <th className="text-right py-2 px-3">R</th>
                <th className="text-right py-2 px-3">PnL USDT</th>
                <th className="text-left py-2 px-3">Estado</th>
                <th className="text-right py-2 px-3">Acción</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={9} className="py-4 px-3 text-center text-muted-foreground">Cargando...</td></tr>
              )}
              {!loading && items.length === 0 && (
                <tr><td colSpan={9} className="py-6 px-3 text-center text-muted-foreground" data-testid="empty-positions">Sin posiciones registradas todavía.</td></tr>
              )}
              {!loading && items.map((p) => {
                const pnl = p.cierre?.pnl_usdt ?? 0;
                const r = p.cierre?.r_multiplo ?? 0;
                return (
                  <tr key={p.position_id} className="border-t border-border">
                    <td className="py-2 px-3 font-mono-num">{p.par}</td>
                    <td className="py-2 px-3">{p.estrategia}</td>
                    <td className="py-2 px-3 text-right font-mono-num">{fmt(p.ejecucion?.entry_fill)}</td>
                    <td className="py-2 px-3 text-right font-mono-num">{fmt(p.ejecucion?.stop_inicial)}</td>
                    <td className="py-2 px-3 text-right font-mono-num">{fmt(p.cierre?.precio_salida)}</td>
                    <td className={`py-2 px-3 text-right font-mono-num ${r > 0 ? 'pnl-pos' : r < 0 ? 'pnl-neg' : 'pnl-neutral'}`}>{fmt(r)}</td>
                    <td className={`py-2 px-3 text-right font-mono-num ${pnl > 0 ? 'pnl-pos' : pnl < 0 ? 'pnl-neg' : 'pnl-neutral'}`}>{fmt(pnl)}</td>
                    <td className="py-2 px-3"><span className="text-xs">{p.estado}</span></td>
                    <td className="py-2 px-3 text-right">
                      {p.estado === 'abierta' && (
                        <button className="text-xs px-2 py-1 rounded border border-border hover:bg-muted" onClick={() => close(p.position_id)} data-testid={`close-${p.position_id}`}>Cerrar</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
